module.exports = __webpack_public_path__ + "media/styles/images/png/checkbox-unchecked-gray-bdab683894b8348b96010d99568fb580.png";